import { useState } from 'react';
import { Plus, Clock, Trash2, X } from 'lucide-react';
import { PageHeader } from '@/components/shared/PageHeader';
import { Button } from '@/components/ui/button';
import { StatusBadge } from '@/components/shared/StatusBadge';

const REPORT_TYPES = ['Monthly Attendance Summary','Payroll Report','Leave Balance Report','Expense Report','Employee Directory','PF/ESIC Challan'];
const FREQUENCIES = ['Daily','Weekly','Monthly'];

const MOCK_SCHEDULED = [
  { id: 'sr-001', name: 'Monthly Attendance Summary', frequency: 'Monthly', next_run: '2026-07-01', email: 'hr@company.com', status: 'ACTIVE' },
  { id: 'sr-002', name: 'Payroll Report', frequency: 'Monthly', next_run: '2026-07-03', email: 'accounts@company.com', status: 'ACTIVE' },
  { id: 'sr-003', name: 'Leave Balance Report', frequency: 'Weekly', next_run: '2026-06-15', email: 'manager@company.com', status: 'PAUSED' },
];

function AddScheduleModal({ onClose }) {
  const [form, setForm] = useState({ name: REPORT_TYPES[0], frequency: 'Monthly', email: '' });
  const inputCls = "w-full h-10 px-3 bg-[var(--bg-muted)] border border-[var(--border)] rounded-[10px] text-[14px] text-[var(--text-primary)] focus:outline-none focus:ring-2 focus:ring-[var(--accent)]";
  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4" onClick={e => e.target === e.currentTarget && onClose()}>
      <div className="bg-[var(--bg-card)] rounded-[20px] w-full max-w-sm border border-[var(--border)] shadow-[var(--shadow-xl)] fade-in">
        <div className="flex items-center justify-between px-6 pt-5 pb-4 border-b border-[var(--border)]">
          <h2 className="text-[18px] font-bold text-[var(--text-primary)]">Schedule Report</h2>
          <button onClick={onClose} className="p-1.5 rounded-[6px] hover:bg-[var(--bg-muted)]"><X size={15}/></button>
        </div>
        <div className="px-6 py-5 space-y-4">
          {[['Report Type','name','select'],['Frequency','frequency','select'],['Send to Email','email','input']].map(([label, key, type]) => (
            <div key={key} className="space-y-1.5">
              <label className="text-[13px] font-semibold text-[var(--text-primary)]">{label}</label>
              {type === 'select' ? (
                <select value={form[key]} onChange={e => setForm(f => ({ ...f, [key]: e.target.value }))} className={inputCls}>
                  {(key === 'name' ? REPORT_TYPES : FREQUENCIES).map(o => <option key={o} value={o}>{o}</option>)}
                </select>
              ) : (
                <input type="email" value={form[key]} onChange={e => setForm(f => ({ ...f, [key]: e.target.value }))} placeholder="recipient@company.com" className={inputCls}/>
              )}
            </div>
          ))}
          <div className="flex gap-2 pt-1">
            <Button className="flex-1" onClick={onClose}>Schedule</Button>
            <Button variant="outline" onClick={onClose}>Cancel</Button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default function ScheduledReportsPage() {
  const [reports, setReports] = useState(MOCK_SCHEDULED);
  const [showAdd, setShowAdd] = useState(false);

  return (
    <div className="space-y-5 fade-in">
      <PageHeader
        title="Scheduled Reports"
        subtitle="Auto-delivered reports via email"
        breadcrumb={[{ label: 'Reports', href: '/reports' }, { label: 'Scheduled' }]}
        actions={<Button size="sm" icon={Plus} onClick={() => setShowAdd(true)}>New Schedule</Button>}
      />

      <div className="card p-0 overflow-hidden divide-y divide-[var(--border)]">
        {reports.map(r => (
          <div key={r.id} className="flex items-center justify-between px-5 py-4 hover:bg-[var(--bg-muted)] transition-colors">
            <div className="flex items-center gap-3">
              <div className="w-9 h-9 rounded-[10px] bg-[var(--accent)]/10 flex items-center justify-center">
                <Clock size={16} className="text-[var(--accent)]"/>
              </div>
              <div>
                <p className="text-[14px] font-semibold text-[var(--text-primary)]">{r.name}</p>
                <p className="text-[12px] text-[var(--text-tertiary)]">{r.frequency} · Next: {r.next_run} · {r.email}</p>
              </div>
            </div>
            <div className="flex items-center gap-3">
              <StatusBadge status={r.status}/>
              <button onClick={() => setReports(rs => rs.filter(x => x.id !== r.id))}
                className="p-1.5 rounded-[6px] hover:bg-[var(--danger)]/10 text-[var(--text-tertiary)] hover:text-[var(--danger)]">
                <Trash2 size={14}/>
              </button>
            </div>
          </div>
        ))}
        {reports.length === 0 && <div className="px-5 py-12 text-center text-[14px] text-[var(--text-tertiary)]">No scheduled reports</div>}
      </div>

      {showAdd && <AddScheduleModal onClose={() => setShowAdd(false)}/>}
    </div>
  );
}
